import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TerraNumberPipe} from '../../../../shared/pipes/TerraNumber.pipe';

@Component({
  selector: 'terra-lp-leverage-table',
  templateUrl: './lp-leverage-table.component.html',
  styleUrls: ['./lp-leverage-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpLeverageTableComponent implements OnInit, OnChanges {
  @Input() irrWithLeverage: number;
  @Input() irrWithoutLeverage: number;
  @Input() totalGainsWithLeverage: number;
  @Input() totalGainsWithoutLeverage: number;

  readonly displayedColumns = ['title', 'withLeverage', 'withoutLeverage'];
  dataSource = this.getTableData();

  constructor(private numberPipe: TerraNumberPipe) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.irrWithLeverage?.currentValue || changes.irrWithoutLeverage?.currentValue ||
        changes.totalGainsWithLeverage?.currentValue || changes.totalGainsWithoutLeverage?.currentValue) {
      this.dataSource = this.getTableData();
    }
  }

  private getTableData() {
    return [
      { title: 'Cash Investment', withLeverage: `$${this.numberPipe.transform(180000)}`, withoutLeverage: `$${this.numberPipe.transform(180000)}` },
      { title: 'Leverage (@8% APY)', withLeverage: `$${this.numberPipe.transform(60000)}`, withoutLeverage: '$0' },
      { title: 'Total Investment', withLeverage: `$${this.numberPipe.transform(240000)}`, withoutLeverage: `$${this.numberPipe.transform(180000)}` },
      { title: 'Total Gains', withLeverage: `$${this.numberPipe.transform(this.totalGainsWithLeverage)}`, withoutLeverage: `$${this.numberPipe.transform(this.totalGainsWithoutLeverage)}` },
      { title: 'IRR', withLeverage: `${this.numberPipe.transform(this.irrWithLeverage * 100)}%`, withoutLeverage: `${this.numberPipe.transform(this.irrWithoutLeverage * 100)}%` }
    ];
  }
}
